var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateEmpresa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 103.73 120.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e8f1fa;}.cls-2{fill:#00c9db;}.cls-3{fill:#c7e6f9;}.cls-4{fill:#e14d5f;}.cls-5{fill:#d91a32;}.cls-6{fill:#f6911e;}.cls-7{fill:#f18122;}.cls-8{fill:#359ebb;}.cls-9{fill:#00d2e1;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.68 89.75 63.44 89.75 63.44 120.29 91.45 120.29 96.03 10.13 70.53 10.13 50.68 89.75z",
    className: "cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.07 120.26 15.27 120.26 15.27 120.29 43.13 120.29 43.13 120.02 43.07 120.26z",
    className: "cls-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.13 120.02 43.13 89.75 50.68 89.75 70.53 10.13 9.46 10.13 15.27 120.26 43.07 120.26 43.13 120.02z",
    className: "cls-3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.66,0H73.05L70.8,9l-.27,1.09H98.66A5.07,5.07,0,1,0,98.66,0",
    className: "cls-4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07,0a5.07,5.07,0,1,0,0,10.13H70.53L70.8,9l2.25-9Z",
    className: "cls-5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.68 89.75 43.13 120.02 43.13 120.29 63.44 120.29 63.44 89.75 50.68 89.75z",
    className: "cls-6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.13 120.02 50.68 89.75 43.13 89.75 43.13 120.02z",
    className: "cls-7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.37 22.8H44.89V40.11H24.37z",
    className: "cls-8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3 22.8H80.82V40.11H60.3z",
    className: "cls-9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.37 51.41H44.89V68.72H24.37z",
    className: "cls-8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3 51.41H80.82V68.72H60.3z",
    className: "cls-9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.37 22.8 63.05 40.11 60.3 40.11 60.3 22.8 67.37 22.8z",
    className: "cls-8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateEmpresa);
export default __webpack_public_path__ + "static/media/create-empresa.656fd3e4cfae141b7def3333d8448a4a.svg";
export { ForwardRef as ReactComponent };